<template>
  <div>
    <!-- Header Section -->
    <h2 class="header">
      Chat with Experts
      <a class="view-all" @click="goToExpertChat()">View All ({{ expert_list.length }})</a>
    </h2>

    <!-- Profiles Section -->
    <div v-if="expert_profiles.length > 0" class="flex-sections">
      <div v-for="(profile, index) in expert_profiles" :key="index" class="profile-card">
        <div class="image">
          <img :src="profile.profileImage" class="profile-img" v-if="profile.profileImage.length" />
          <!-- <img :src="profile.profileImage" /> -->
          <img class="profile-img" src="../assets/images/navBar/avatar.jpg" v-else />
        </div>
        <div class="text-data">
          <div class="name-status">
            <span class="name">{{ profile.fullName }}</span>
            <img :src="profile.verifyIcon" alt="Verify Icon" class="verify-icon" />
          </div>
          <span class="status" :class="{ online: profile.status === 'online', offline: profile.status === 'offline' }">
            {{ profile.status.charAt(0).toUpperCase() + profile.status.slice(1) }}
          </span>
        </div>

        <div class="expert-skills">
          <span>{{ profile.expertSkills || 'N/A' }}</span>
        </div>

        <div class="buttons">
          <button class="button" @click="goToExpertChat()">
            <img src="@/assets/images/Chat Icon.svg" alt="Chat" class="button-icon" />
            Chat
          </button>
        </div>
      </div>
    </div>

    <!-- No Data Found Section -->
    <NoDataFound v-else />
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';
import moment from 'moment';

export default {
  name: 'ProfileCardsContainer',
  props: ['expert_list'],

  components: {
    NoDataFound,
  },
  data() {
    return {
      // expert_profiles: [],
      isLoading: false,
      serverHostName: serverHostName,
    };
  },
  computed: {
    expert_profiles() {
      return this.expert_list.slice(0, 2);
    },
  },
  mounted() {
    // this.getExpertProfiles();
  },
  methods: {
    goToExpertChat() {
      this.$router.push({ path: '/expert-list' });
    },
    // getExpertProfiles() {
    //   this.isLoading = true; // Set loading state
    //   serverAddr
    //     .get('/user/admin/chat_expert_list')
    //     .then((response) => {
    //       this.isLoading = false;

    //       if (response.data.status) {
    //         this.profiles = response.data.data.slice(0, 2).map((profile) => ({
    //           fullName: profile.full_name,
    //           profileImage: profile.picture ? ${this.serverHostName}${profile.picture} : require('../assets/images/navBar/avatar.jpg'), // Fallback image
    //           verifyIcon: require('../assets/images/verify.svg'),
    //           status: 'offline',
    //         }));
    //       } else {
    //         console.error('Error fetching profiles:', response.data.validation);
    //       }
    //     })
    //     .catch((error) => {
    //       this.isLoading = false; // Reset loading state on error
    //       console.error('Error fetching profiles:', error);
    //     });
    // },
  },
};
</script>

<style scoped lang="scss">
/* Header Section */
.header {
  font-size: 15px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 10px;
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .view-all {
    font-size: 14px;
    font-weight: 500;
    color: #2d2e8d;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #0e4bf1;
    }
  }
}

/* Profile Cards Section */
.flex-sections {
  display: flex;
  gap: 10px;
  margin-top: 10px;

  > * {
    flex: 1;
  }
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(179.82deg, #ffffff 24.54%, #e5f1ff 99.84%);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  flex: 1;
  max-width: 100%;
  border-bottom: 1px solid #2488ff;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 25%;
    width: 100%;
    border-radius: 10px 10px 0 0;
    background: url('../assets/images/Chat Background.svg') center/cover no-repeat;
  }

  .image {
    position: relative;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    // background-color: #4070f4;
    padding: 3px;
    margin-bottom: 10px;

    .profile-img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 50%;
      border: 3px solid #fff;
    }
  }

  .text-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;

    .name-status {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      .name {
        font-size: 14px;
        font-weight: 700;
        margin-right: 5px;
        color: #000000;
        word-break: break-word;
        max-width: 140px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
      }

      .verify-icon {
        width: 12px;
        height: 12px;
      }
    }

    .status {
      font-size: 12px;
      font-weight: 600;
      margin-top: 10px;

      &.online {
        color: green;
      }

      &.offline {
        color: red;
      }
    }
  }

  .expert-skills {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #959595;
    text-align: center;
  }

  .buttons {
    display: flex;
    align-items: center;
    margin-top: 20px;
    width: 100%; // Ensure full width of the container

    .button {
      flex: 1; // Make button take full available width
      color: #fff;
      font-size: 14px;
      font-weight: 700;
      border: none;
      border-radius: 100px;
      margin: 0 10px;
      padding: 8px 24px;
      background-color: #0ba042;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &:hover {
        background-color: darken(#0ba042, 10%);
      }

      .button-icon {
        width: 15px;
        height: 15px;
        margin-right: 8px;
      }
    }
  }
}
@media (max-width: 1200px) {
  .profile-card {
    padding: 20px 10px;
  }
}
/* Mobile View Styles */
@media (max-width: 768px) {
  .profile-card {
    padding: 10px;
    .image {
      height: 50px;
      width: 50px;

      .profile-img {
        height: 100%;
        width: 100%;
      }
    }

    .text-data {
      .name-status {
        .name {
          font-size: 11px;
          margin-right: 5px;
          max-width: 100px;
        }

        .verify-icon {
          width: 11px;
          height: 12px;
        }
      }

      .status {
        font-size: 10px;
        font-weight: 600;
        margin-top: 5px;
      }
    }

    .expert-skills {
      font-size: 8px;
      font-weight: 500;
    }

    .buttons {
      margin-top: 10px;
      .button {
        font-size: 12px;
        font-weight: 700;
        border: none;

        .button-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}
</style>